const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/todo-list',
  component: Module,
  children: [
    {
      path: '',
      component: Home,
      name: 'todo-list',
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
